// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  pelletId: __t.string().primaryKey(),
  lobbyId: __t.string(),
  posX: __t.i32(),
  posY: __t.i32(),
  velX: __t.i32(),
  velY: __t.i32(),
  age: __t.f32(),
  value: __t.u16(),
  lifetime: __t.f32(),
  updatedAt: __t.timestamp(),
});
